import React from 'react';
import ServiceCard from './ServiceCard';
import './ServicesList.css';

/**
 * ServicesList Component - Displays a list of community services
 */
function ServicesList({
  services,
  type,
  onOfferHelp,
  isAuthenticated,
  memberInfo,
  onUpdate
}) {
  // Group services by urgency for "needed" type
  const groupServicesByUrgency = () => {
    if (type !== 'needed') return { normal: services };
    
    const grouped = {
      emergency: [],
      urgent: [],
      normal: []
    };
    
    services.forEach(service => {
      const urgency = service.urgency || 'normal';
      if (grouped[urgency]) {
        grouped[urgency].push(service);
      }
    });
    
    return grouped;
  };

  const groupedServices = groupServicesByUrgency();

  return (
    <div className="services-list">
      {type === 'needed' && (
        <>
          {/* Emergency Services */}
          {groupedServices.emergency.length > 0 && (
            <div className="urgency-group emergency-group">
              <div className="urgency-header">
                <span className="urgency-badge emergency">EMERGENCY</span>
                <span className="urgency-count">{groupedServices.emergency.length} request{groupedServices.emergency.length !== 1 ? 's' : ''}</span>
              </div>
              <div className="services-grid">
                {groupedServices.emergency.map(service => (
                  <ServiceCard
                    key={service.id}
                    service={service}
                    type={type}
                    onOfferHelp={onOfferHelp}
                    isAuthenticated={isAuthenticated}
                    isOwn={memberInfo?.id === service.member_id}
                    onUpdate={onUpdate}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Urgent Services */}
          {groupedServices.urgent.length > 0 && (
            <div className="urgency-group urgent-group">
              <div className="urgency-header">
                <span className="urgency-badge urgent">URGENT</span>
                <span className="urgency-count">{groupedServices.urgent.length} request{groupedServices.urgent.length !== 1 ? 's' : ''}</span>
              </div>
              <div className="services-grid">
                {groupedServices.urgent.map(service => (
                  <ServiceCard
                    key={service.id}
                    service={service}
                    type={type}
                    onOfferHelp={onOfferHelp}
                    isAuthenticated={isAuthenticated}
                    isOwn={memberInfo?.id === service.member_id}
                    onUpdate={onUpdate}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Normal Services */}
          {groupedServices.normal.length > 0 && (
            <div className="urgency-group normal-group">
              {(groupedServices.emergency.length > 0 || groupedServices.urgent.length > 0) && (
                <div className="urgency-header">
                  <span className="urgency-badge normal">Other Requests</span>
                  <span className="urgency-count">{groupedServices.normal.length} request{groupedServices.normal.length !== 1 ? 's' : ''}</span>
                </div>
              )}
              <div className="services-grid">
                {groupedServices.normal.map(service => (
                  <ServiceCard
                    key={service.id}
                    service={service}
                    type={type}
                    onOfferHelp={onOfferHelp}
                    isAuthenticated={isAuthenticated}
                    isOwn={memberInfo?.id === service.member_id}
                    onUpdate={onUpdate}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {type === 'offered' && (
        <div className="services-grid">
          {services.map(service => (
            <ServiceCard
              key={service.id}
              service={service}
              type={type}
              onOfferHelp={onOfferHelp}
              isAuthenticated={isAuthenticated}
              isOwn={memberInfo?.id === service.member_id}
              onUpdate={onUpdate}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ServicesList;